import { type FC, type ComponentProps, lazy, useState, useEffect } from 'react';

const NftProfileImportCollectionModal = lazy(() => import('./NftProfileImportCollectionModal.tsx'));

type Props = ComponentProps<typeof NftProfileImportCollectionModal>;

// not "is" or "has been" bc this hook captures if the current value matched the
// target value during the current or any prior value **change**. it's basically
// a generic version of "dirty"/"touched" form state
const useWas = <Current extends Return, Target extends Return & Current, Return = Current>(
    current: Current,
    target: Target
): Return => {
    const [was, setWas] = useState(current);
    useEffect(() => {
        // @ts-expect-error broken with ts 4.9
        if (was !== target && current === target) setWas(current);
    }, [was, current, target]);
    return was;
};

export const NftProfileImportCollectionModalLazy: FC<Props> = props =>
    useWas(props.isOpen, true) ? <NftProfileImportCollectionModal {...props} /> : null;
